import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { IUser, UserProfileTypes } from 'models/User';
import { ITableModel } from '../interface';
import { ITickets } from 'models/Ticket';

import Text from 'components/Text';
import { Button } from 'components/Button';
import { Visibility } from 'components/Visibility';
import toast from 'components/Toast/dispatch';
import { Row } from 'components/Layout/Grid';

import iconEdit from 'img/edit-icon-table.svg';
import iconSendEmail from 'img/icon-send-email.svg';
import iconOrderLost from 'img/icon-order-lost.svg';
import successIcon from 'img/success-img.svg';
import errorIcon from 'img/error-img.svg';

import '../styles.scss';

import { SelectCustomerIdIsArray } from 'utils/SelectCustomerIdIsArray';
import { EnumToArray } from 'utils/enumArray/enumHelpers';

import DevolutionTicketService from 'services/Ticket/Devolution/devolutionTicket.service';
import ReviewOrderLost from 'pages/ReviewOrderLost';
import { AdverseEventsForm } from 'pages/AdverseEventsForm';

const _devolutionTicketService = new DevolutionTicketService();

const labelCategory = {
  label: 'Categoria',
  key: 'protocolCategory',
  size: 130,
  maxSize: 130,
  Component: (data: ITickets) => (
    <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
      {data?.ticketCategoryView?.label}
    </Text>
  ),
};

const labelReason = {
  label: 'Motivo',
  key: 'ticketReason',
  size: 120,
  Component: (data: ITickets) => (
    <Text className="color-blue-gray first-letter-uppercase" size={12} showTip>
      {data?.ticketReasonView?.label}
    </Text>
  ),
};

const labelOpenAt = {
  label: 'Aberto em',
  key: 'createdDate',
  type: 'date/hour',
  size: 130,
  maxSize: 130,
};

const labelOpenBy = {
  label: 'Por',
  key: 'userWhoCreated.fullName',
  noFilter: true,
};

const ticketsModelBasic: Array<ITableModel> = [
  labelCategory,
  labelReason,
  labelOpenAt,
  labelOpenBy,
];

function hideButton(ticket: ITickets) {
  return !ticket.isAbleToEdit;
}

const resendDevolutionApprovalMail = async (data: any) => {
  try {
    await _devolutionTicketService.resendDevolutionApprovalMail(data.id);
    toast.info("Reenvio de e-mail", `Operação solicitada com sucesso para o protocolo ${data.protocolNumber}.`, successIcon, "Fechar");
  } catch (error) {
    toast.info("Reenvio de e-mail", `Operação falhou para o protocolo ${data.protocolNumber}.`, errorIcon, "Fechar");
  }
};

type TextModelTicketProps = {
  ticket: ITickets;
};

const TextModelTicket = (props: TextModelTicketProps) => {

  const { ticket } = props;

  return (
    <Text className="color-blue-gray" size={12} showTip>
      {EnumToArray(UserProfileTypes).find(
        (item) =>
          item.key.toLowerCase() === ticket.responsibleGroup?.toLowerCase()
      )?.value ?? ''}
    </Text>
  );
};

const ButtonReviewOrderLost = (props: TextModelTicketProps) => {

  const dispatch = useDispatch();
  const { ticket } = props;

  const innerWidth = 1900;
  const innerWidthThreshold = window.innerWidth < innerWidth ? 80 : 60;

  return (
    <Visibility visible={ticket.isAbleToReviewOrderLostProcess}>
      <Row className="w-100 justify-center" style={{ paddingRight: 2 }}>
        <Button
          width="auto"

          onClick={() =>
            dispatch({
              type: 'OPEN_SLIDER',
              data: {
                title: 'Revisar processo de extravio',
                content: ReviewOrderLost,
                state: { ticket },
                width: innerWidthThreshold
              },
            })
          }
        >
          <img width={20} src={iconOrderLost} alt="" />
        </Button>
      </Row>
    </Visibility>
  );
};

const ButtonAdverseEvents = (props: TextModelTicketProps) => {

  const dispatch = useDispatch();
  const { ticket } = props;

  const innerWidth = 1900;
  const innerWidthThreshold = window.innerWidth < innerWidth ? 80 : 60;

  return (
    <Visibility visible={ticket.isAbleAdverseEventsProcess}>
      <Row className="w-100 justify-center" style={{ paddingRight: 2 }}>
        <Button
          width="auto"

          onClick={() =>
            dispatch({
              type: 'OPEN_SLIDER',
              data: {
                title: 'Registro de eventos adversos',
                content: AdverseEventsForm,
                state: { ticket },
                width: innerWidthThreshold
              },
            })
          }
        >
          <img width={20} src={iconOrderLost} alt="" />
        </Button>
      </Row>
    </Visibility>
  );
};

const modelTicket: Array<ITableModel> = [
  { ...labelCategory, size: 140, maxSize: 140 },
  { ...labelReason },
  { label: 'Cliente', key: 'customerName', noFilter: true },
  labelOpenAt,
  labelOpenBy,
  {
    label: 'Grupo responsável',
    key: 'responsibleGroup',
    size: 120,
    maxSize: 120,
    Component: (data: ITickets) => (
      <TextModelTicket ticket={data} />
    ),
  },
  {
    label: 'Última interação',
    key: 'updatedDate',
    type: 'date/hour',
    size: 130,
    maxSize: 130,
  },
  {
    label: 'Status',
    key: 'phaseStatus'
  },
  /*{
    label: '',
    key: '',
    size: 50,
    maxSize: 65,
    isButton: true,
    Component: (data: ITickets) => {
      const user = useSelector((state: { user: IUser; }) => state.user);
      const isCustomer: boolean = user?.userType === 'customer';
      const isSupplier: boolean = user?.userType === 'supplier';

      return (
        <Row className="w-100 justify-center">
          <Visibility visible={Array.isArray(user?.selectedCustomerId) && !data.isAbleToReviewOrderLostProcess && !data.isAbleAdverseEventsProcess}>
            <div onClick={() => !SelectCustomerIdIsArray()}>
              <Button width="auto" hide={hideButton(data)} disabled={isCustomer || isSupplier}>
                <img src={iconEdit} alt="" />
              </Button>
            </div>
          </Visibility>
          <Visibility visible={!Array.isArray(user?.selectedCustomerId) && !data.isAbleToReviewOrderLostProcess && !data.isAbleAdverseEventsProcess}>
            <Link to='/abrir-protocolo' state={data}>
              <Button width="auto" hide={hideButton(data)} disabled={isCustomer || isSupplier}>
                <img src={iconEdit} alt="" />
              </Button>
            </Link>
          </Visibility>
          <Visibility visible={data.isAbleToResendDevolutionApprovalMail}>
            <Button
              className="px-0"
              onClick={() => resendDevolutionApprovalMail(data)}
              width="auto"
            >
              <img
                width={20}
                src={iconSendEmail}
                alt=""
                style={{ marginBottom: 2, marginLeft: 4 }}
              />
            </Button>
          </Visibility>
          <ButtonReviewOrderLost ticket={data} />
          <ButtonAdverseEvents ticket={data} />
        </Row>
      );
    }
  },*/
];

const modelLinkTicket: Array<ITableModel> = [
  { ...labelCategory, size: 140, maxSize: 140 },
  { ...labelReason },
  labelOpenAt,
  labelOpenBy,
  {
    label: 'Grupo responsável',
    key: 'responsibleGroup',
    size: 120,
    maxSize: 120,
    Component: (data: ITickets) => (
      <TextModelTicket ticket={data} />
    ),
  },
  { label: 'Status', key: 'phaseStatus' },
];

export { ticketsModelBasic, modelTicket, modelLinkTicket, ButtonReviewOrderLost, ButtonAdverseEvents };
